var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgI7(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.125 3.75C14.6924 3.75 3.75 14.6924 3.75 28.125C3.75 41.5576 14.6924 52.5 28.125 52.5C41.5576 52.5 52.5 41.5576 52.5 28.125C52.5 14.6924 41.5576 3.75 28.125 3.75ZM28.125 7.5C39.5361 7.5 48.75 16.7139 48.75 28.125C48.75 39.5361 39.5361 48.75 28.125 48.75C16.7139 48.75 7.5 39.5361 7.5 28.125C7.5 16.7139 16.7139 7.5 28.125 7.5ZM28.3447 15C23.8037 15.2637 20.0977 19.0723 20.0977 23.7012H23.8477C23.8477 20.6543 26.4844 18.2666 29.707 18.8232C32.0068 19.2187 33.8232 21.4746 33.75 23.8477C33.6914 25.9277 32.4756 27.2461 30.6885 28.0371C29.5752 28.5352 28.5205 29.0039 27.627 29.9414C26.7334 30.8789 26.25 32.2705 26.25 33.75H30C30 32.9004 30.1172 32.7686 30.3516 32.5195C30.5713 32.2852 31.1865 31.9189 32.1973 31.4648C34.9951 30.249 37.3975 27.5684 37.5 23.9648C37.6318 19.7021 34.5703 15.8496 30.3369 15.1172C29.6631 15.0146 28.9893 14.9707 28.3447 15ZM26.25 37.5V41.25H30V37.5H26.25Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgI7);
export default __webpack_public_path__ + "static/media/i7.447f6b6ec75fc800fa44119580eb5b99.svg";
export { ForwardRef as ReactComponent };